(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testro-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('testro-turn')) {
    class TestroTurn extends HTMLElement {
      connectedCallback() {
        this.img = this.querySelector('.tx-hero__frame');
        const all = (this.img.dataset.frames || '').split('|').filter(Boolean);
        if (!all.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const mobile = window.matchMedia('(max-width: 749px)').matches;
        this.urls = mobile ? all.filter((_, i) => i % 2 === 0) : all;
        this.turns = parseInt(this.dataset.turns, 10) || 2;
        this.host = this.closest('[data-tx-pin]');
        this.frames = new Array(this.urls.length);
        this.current = -1;
        this.visible = true;
        // Canvas: kareler önceden çözülmüş bitmap olarak çizilir (img.src değiştirmekten çok daha hızlı)
        this.canvas = document.createElement('canvas');
        this.canvas.className = 'tx-hero__frame tx-hero__canvas';
        this.canvas.setAttribute('aria-hidden', 'true');
        const dpr = Math.min(window.devicePixelRatio || 1, mobile ? 2 : 1.5);
        this.cw = Math.round((this.img.clientWidth || 300) * dpr);
        this.ch = Math.round(this.cw * (802 / 454));
        this.canvas.width = this.cw;
        this.canvas.height = this.ch;
        this.ctx = this.canvas.getContext('2d');
        const start = () => this.preload();
        if (document.readyState === 'complete') setTimeout(start, 150); else window.addEventListener('load', () => setTimeout(start, 150), { once: true });
        this.onScroll = () => {
          if (this.raf || !this.visible) return;
          this.raf = requestAnimationFrame(() => { this.raf = 0; this.draw(); });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver((e) => { this.visible = e[0].isIntersecting; if (this.visible) this.onScroll(); });
          this.io.observe(this.host || this);
        }
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        document.removeEventListener('scroll', this.onScroll, true);
        if (this.io) this.io.disconnect();
      }
      async preload() {
        const decode = async (u, i) => {
          try {
            const res = await fetch(u, { cache: 'force-cache' });
            const blob = await res.blob();
            this.frames[i] = 'createImageBitmap' in window ? await createImageBitmap(blob, { resizeWidth: this.cw, resizeQuality: 'high' }) : await new Promise((ok) => { const im = new Image(); im.onload = () => ok(im); im.src = URL.createObjectURL(blob); });
          } catch (e) {}
        };
        // Önce seyrek kareler (hızlı ilk tepki), sonra kalanlar
        const order = [];
        for (let step = 8; step >= 1; step = Math.floor(step / 2)) for (let i = 0; i < this.urls.length; i += step) if (!order.includes(i)) order.push(i);
        const queue = order.slice();
        const worker = async () => { while (queue.length) { const i = queue.shift(); await decode(this.urls[i], i); } };
        await Promise.all([worker(), worker(), worker()]);
        if (!this.canvas.isConnected) { this.img.after(this.canvas); this.img.style.visibility = 'hidden'; this.img.style.position = 'absolute'; }
        this.draw();
      }
      draw() {
        if (!this.canvas.isConnected) return;
        const p = parseFloat(this.host && this.host.style.getPropertyValue('--p')) || 0;
        const n = this.urls.length;
        let i = Math.round(p * this.turns * n) % n;
        for (let k = 0; k < n && !this.frames[i]; k++) i = (i + 1) % n;
        if (!this.frames[i] || i === this.current) return;
        this.current = i;
        this.ctx.clearRect(0, 0, this.cw, this.ch);
        this.ctx.drawImage(this.frames[i], 0, 0, this.cw, this.ch);
      }
    }
    customElements.define('testro-turn', TestroTurn);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testro-reels"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('testro-reels')) {
    class TestroReels extends HTMLElement {
      connectedCallback() {
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.section = this.closest('.tx-rl');
        this.modal = this.section.querySelector('.tx-rl__modal');
        this.items = Array.from(this.querySelectorAll('.tx-rl__item'));
        this.ratios = new Map();
        this.userPaused = new Set();
        if (!this.reduce && 'IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => {
            entries.forEach((e) => this.ratios.set(e.target, e.isIntersecting ? e.intersectionRatio : 0));
            this.pickActive();
          }, { threshold: [0, 0.25, 0.5, 0.75, 1] });
          this.items.forEach((it) => this.io.observe(it));
        }
        this.addEventListener('click', (e) => {
          const t = e.target.closest('.tx-rl__toggle, .tx-rl__card, .tx-rl__sound');
          if (!t) return;
          e.stopPropagation();
          const item = t.closest('.tx-rl__item');
          const v = item.querySelector('video');
          // Karta ya da ses düğmesine dokununca: sessizse sesi açıp oynat, sesliyse sesi kapat (kart) / sustur (düğme)
          if (t.classList.contains('tx-rl__sound') || (t.classList.contains('tx-rl__card') && v && v.muted)) {
            const on = !(v && !v.muted && item.classList.contains('is-playing'));
            this.soundOn = on;
            this.userPaused.delete(item);
            this.items.forEach((o) => { if (o !== item) this.stop(o); });
            this.setSound(item, on);
            this.play(item);
            return;
          }
          if (item.classList.contains('is-playing')) {
            this.userPaused.add(item);
            this.stop(item);
          } else {
            this.userPaused.delete(item);
            this.items.forEach((o) => { if (o !== item) this.stop(o); });
            this.play(item);
          }
        });
        this.modal.querySelector('.tx-rl__close').addEventListener('click', () => this.modal.close());
        this.modal.addEventListener('click', (e) => { if (e.target === this.modal) this.modal.close(); });
        this.modal.addEventListener('close', () => { this.modal.querySelector('.tx-rl__modal-inner').innerHTML = ''; });
      }
      disconnectedCallback() { if (this.io) this.io.disconnect(); }
      play(item) {
        const v = item.querySelector('video');
        if (!v) return;
        if (v.preload === 'none') v.preload = 'metadata';
        v.play().then(() => this.setState(item, true)).catch(() => {
          // Tarayıcı sesli oynatmaya izin vermezse sessiz dene
          if (!v.muted) { this.setSound(item, false); v.play().then(() => this.setState(item, true)).catch(() => {}); }
        });
      }
      stop(item) {
        const v = item.querySelector('video');
        if (v) v.pause();
        this.setState(item, false);
        this.setSound(item, false);
      }
      setSound(item, on) {
        const v = item.querySelector('video');
        if (v) v.muted = !on;
        item.classList.toggle('has-sound', on);
        const b = item.querySelector('.tx-rl__sound');
        if (b) b.setAttribute('aria-label', on ? 'Sesi kapat' : 'Sesi aç');
      }
      setState(item, on) {
        item.classList.toggle('is-playing', on);
        const t = item.querySelector('.tx-rl__toggle');
        if (t) t.setAttribute('aria-label', on ? t.dataset.labelPause : t.dataset.labelPlay);
      }
      pickActive() {
        let best = null, max = 0.6;
        this.ratios.forEach((r, el) => { if (r > max) { max = r; best = el; } });
        this.items.forEach((it) => {
          if (it === best && !this.userPaused.has(it)) {
            if (!it.classList.contains('is-playing')) { if (this.soundOn) this.setSound(it, true); this.play(it); }
          }
          else if (it !== best && it.classList.contains('is-playing')) this.stop(it);
        });
      }
      open(src) {
        if (!src) return;
        const v = src.cloneNode(true);
        v.muted = false;
        v.controls = true;
        v.autoplay = true;
        v.removeAttribute('class');
        const inner = this.modal.querySelector('.tx-rl__modal-inner');
        inner.innerHTML = '';
        inner.appendChild(v);
        this.modal.showModal();
        v.play().catch(() => {});
      }
    }
    customElements.define('testro-reels', TestroReels);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testro-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('testro-tiers')) {
    class TestroTiers extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', () => {
          const v = this.querySelector('.tx-sc__radio:checked')?.value || 1;
          const link = this.closest('section').querySelector('[data-tx-sc-link]');
          if (link) link.href = this.dataset.base + '?paket=' + v;
        });
      }
    }
    customElements.define('testro-tiers', TestroTiers);
  }

  } catch(e) { console.error(e); }
})();
})();
